import { useSegment } from 'common/hooks/segment';
import React from 'react';
import { TutorialDescription } from './TutorialDescription';
import { TutorialVideo } from './TutorialVideo';

interface Props {
  title: string;
  description: string | React.ReactNode;
  tutorialDuration: string;
  youtubeURL?: string;
  tutorialKey: string;
  segmentKey?: string;
  className?: string;
}

export const Tutorial: React.FC<Props> = ({
  title,
  description,
  tutorialDuration,
  youtubeURL,
  tutorialKey,
  segmentKey,
  className,
}) => {
  const [displayTutorial, setDisplayTutorial] = React.useState(false);
  const localStorageKey = `bc-tutorial-${tutorialKey}`;
  const { track } = useSegment();

  React.useEffect(() => {
    const tutorial = localStorage.getItem(localStorageKey);
    if (!tutorial) {
      setDisplayTutorial(true);
    }
  }, [tutorialKey, localStorageKey]);

  if (!displayTutorial) {
    return null;
  }

  const handleVideoClick = () => {
    if (segmentKey) {
      track(`User watched ${segmentKey} tutorial`, {}, { includeCompany: true, includeUser: true });
    }
  };

  return (
    <div className={`p-4 bg-blue-100 border border-gray-300 rounded flex space-x-4 ${className}`}>
      <TutorialDescription
        title={title}
        description={description}
        onDismiss={() => {
          localStorage.setItem(localStorageKey, 'dismissed');
          setDisplayTutorial(false);
        }}
      />
      {youtubeURL && (
        <TutorialVideo
          youtubeURL={youtubeURL}
          tutorialDuration={tutorialDuration}
          onClick={handleVideoClick}
        />
      )}
    </div>
  );
};
